import { type IconName } from "icons";

export interface FilterOptionConfig {
  value: string;
  label: string;
  color?: string;
}

export interface FilterGroupConfig {
  filter: string;
  label: string;
  icon: IconName;
  selection: "multiple" | "single";
  options: FilterOptionConfig[];
  emptyOption?: FilterOptionConfig;
  defaultValue?: string;
  search?: {
    placeholder: string;
    emptyMessage: string;
  };
  range?: {
    fromLabel: string;
    toLabel: string;
    applyLabel: string;
    min: number;
    max: number;
    initialFrom: number;
    initialTo: number;
  };
}

export type SelectedFilters = Record<string, string[]>;

export type FilterAction =
  | {
      type: "filter-selected";
      filter: string;
      value: string;
    }
  | {
      type: "filter-deselected";
      filter: string;
      value: string;
    }
  | { type: "filters-cleared" };

export function getNextFilterValues(
  values: string[],
  action: Exclude<FilterAction, { type: "filters-cleared" }>,
) {
  if (action.type === "filter-selected") {
    return [...values, action.value];
  }

  return values.filter((value) => {
    return value !== action.value;
  });
}

export function getSelectedFilterValues(
  selectedFilters: SelectedFilters,
  filter: string,
) {
  return selectedFilters[filter];
}

export function getActiveFilterCount(
  config: FilterGroupConfig[],
  selectedFilters: SelectedFilters,
) {
  return config.reduce((count, group) => {
    const selectedValues = getSelectedFilterValues(
      selectedFilters,
      group.filter,
    );

    return (
      count +
      selectedValues.filter((value) => {
        return value !== group.defaultValue;
      }).length
    );
  }, 0);
}
